// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFieldStateType } from './IFieldStateType';
import {
    IFieldStateTypeFromJSON,
    IFieldStateTypeFromJSONTyped,
    IFieldStateTypeToJSON,
    IFieldStateTypeToJSONTyped,
} from './IFieldStateType';

/**
 * 
 * @export
 * @interface IPrinSetupInfoDto
 */
export interface IPrinSetupInfoDto {
    /**
     * 
     * @type {string}
     * @memberof IPrinSetupInfoDto
     */
    prin_setup: string;
    /**
     * 
     * @type {IFieldStateType}
     * @memberof IPrinSetupInfoDto
     */
    print_setup_state?: IFieldStateType;
}



/**
 * Check if a given object implements the IPrinSetupInfoDto interface.
 */
export function instanceOfIPrinSetupInfoDto(value: object): value is IPrinSetupInfoDto {
    if (!('prin_setup' in value) || value['prin_setup'] === undefined) return false;
    return true;
}

export function IPrinSetupInfoDtoFromJSON(json: any): IPrinSetupInfoDto {
    return IPrinSetupInfoDtoFromJSONTyped(json, false);
}

export function IPrinSetupInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPrinSetupInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'prin_setup': json['prin_setup'],
        'print_setup_state': json['print_setup_state'] == null ? undefined : IFieldStateTypeFromJSON(json['print_setup_state']),
    };
}

export function IPrinSetupInfoDtoToJSON(json: any): IPrinSetupInfoDto {
    return IPrinSetupInfoDtoToJSONTyped(json, false);
}

export function IPrinSetupInfoDtoToJSONTyped(value?: IPrinSetupInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prin_setup': value['prin_setup'],
        'print_setup_state': IFieldStateTypeToJSON(value['print_setup_state']),
    };
}

